export enum GuardhouseErrorCodes {
  INTERNAL = 'GH0000',
  TIMEOUT = 'GH0001',

  INVALID_TOKEN = 'GH1003',
  INVALID_TOKEN_SIGNATURE = 'GH1004',
  INVALID_TOKEN_EXPIRY = 'GH1005',
  UNAUTHORIZED_SCOPE = 'GH1010',
  INVALID_SCOPE = 'GH1011',
  NO_PERMISSION = 'GH2020',

  INVALID_APP_DOMAIN = 'GH2016',
  SESSION_EXPIRED = 'GH2022',
  REDIRECT_REQUIRED = 'GH2026',

  MFA_REQUIRED = 'GH2027',
}
